import { MainFiltersValues } from "../../models/API";

interface ItemProps extends MainFiltersValues {
  active: boolean;
  groupId: string;
  toggle: (groupId: string, id: string, activate: boolean) => void;
}

export const Item: React.FC<ItemProps> = (props) => {
  const className = `item${props.active ? " active" : ""}`;

  const toggle = () => {
    // If its active we want deactivate
    props.toggle(props.groupId, props.Id, !props.active);
  };

  return (
    <div className={className} onClick={toggle}>
      {props.ImageUrl && (
        <img
          className="fit-box"
          src={process.env.REACT_APP_PROXY_URL_ASSETS + props.ImageUrl}
          alt={props.Text}
        />
      )}
      {props.IconUrl && (
        <img
          className="icon"
          src={process.env.REACT_APP_PROXY_URL_ASSETS + props.IconUrl}
          alt={props.Text}
        />
      )}
      {props.Text}
    </div>
  );
};
